/**
 * Dropdown Hover Fix
 *
 * Fixes Foundation dropdown menus closing too quickly when moving mouse from
 * trigger to dropdown pane. The issue occurs because:
 * 1. data-hover-delay is set too low (20ms) in some dropdowns
 * 2. There's a CSS gap between trigger buttons and dropdown panes
 *
 * This fix adds a grace period when moving between trigger and pane to prevent
 * premature closing.
 */

const CLOSE_DELAY = 300; // ms to wait before closing after mouse leaves
const DROPDOWN_SELECTOR = '[data-toggle][data-toggle^="title_csv"], [data-toggle][data-toggle^="label_status"]';
const DROPDOWN_PANE_SELECTOR = '.dropdown-pane[data-hover="true"]';

$(document).ready(function () {
  initFoundationDropdownFix();
});

/**
 * Initialize hover fix for Foundation dropdowns
 * Works by tracking hover state across both trigger and pane elements
 */
function initFoundationDropdownFix() {
  // Find all dropdown triggers and their associated panes
  $(DROPDOWN_PANE_SELECTOR).each(function () {
    const $pane = $(this);
    const paneId = $pane.attr("id");

    if (!paneId) return;

    const $trigger = $('[data-toggle="' + paneId + '"]');

    if ($trigger.length === 0) return;

    // Create a shared state object for this trigger-pane pair
    const state = {
      closeTimeout: null,
      isOverTrigger: false,
      isOverPane: false,
    };

    // Store state on both elements for access
    $trigger.data("dropdown-hover-state", state);
    $pane.data("dropdown-hover-state", state);

    // Bind events to trigger
    $trigger.on("mouseenter.dropdownFix", function () {
      state.isOverTrigger = true;
      cancelPendingClose(state);
    });

    $trigger.on("mouseleave.dropdownFix", function () {
      state.isOverTrigger = false;
      scheduleCloseIfNeeded($pane, state);
    });

    // Bind events to dropdown pane
    $pane.on("mouseenter.dropdownFix", function () {
      state.isOverPane = true;
      cancelPendingClose(state);
    });

    $pane.on("mouseleave.dropdownFix", function () {
      state.isOverPane = false;
      scheduleCloseIfNeeded($pane, state);
    });
  });

  // Also handle any dropdowns that might be dynamically added
  $(document).on("mouseenter.dropdownFix", DROPDOWN_PANE_SELECTOR, function () {
    const $pane = $(this);
    let state = $pane.data("dropdown-hover-state");

    if (!state) {
      // Initialize state for dynamically added dropdowns
      state = {
        closeTimeout: null,
        isOverTrigger: false,
        isOverPane: false,
      };
      $pane.data("dropdown-hover-state", state);
    }

    state.isOverPane = true;
    cancelPendingClose(state);
  });

  $(document).on("mouseleave.dropdownFix", DROPDOWN_PANE_SELECTOR, function () {
    const $pane = $(this);
    const state = $pane.data("dropdown-hover-state");

    if (state) {
      state.isOverPane = false;
      scheduleCloseIfNeeded($pane, state);
    }
  });
}

/**
 * Cancel any pending close timeout
 */
function cancelPendingClose(state) {
  if (state.closeTimeout) {
    clearTimeout(state.closeTimeout);
    state.closeTimeout = null;
  }
}

/**
 * Schedule dropdown close if mouse is not over trigger or pane
 */
function scheduleCloseIfNeeded($pane, state) {
  // Don't close if mouse is still over trigger or pane
  if (state.isOverTrigger || state.isOverPane) {
    return;
  }

  // Cancel any existing timeout
  cancelPendingClose(state);

  // Schedule close after delay
  state.closeTimeout = setTimeout(function () {
    // Double-check state hasn't changed
    if (!state.isOverTrigger && !state.isOverPane) {
      // Use Foundation's close method if available
      if ($pane.foundation && typeof $pane.foundation === "function") {
        try {
          $pane.foundation("close");
        } catch (e) {
          // Fallback: remove is-open class
          $pane.removeClass("is-open");
          $pane.attr("aria-hidden", "true");
        }
      } else {
        // Fallback for non-Foundation dropdowns
        $pane.removeClass("is-open");
        $pane.attr("aria-hidden", "true");
      }
    }
    state.closeTimeout = null;
  }, CLOSE_DELAY);
}

/**
 * Handle button-dropdown style dropdowns (non-Foundation)
 */
function fixButtonDropdowns() {
  const VIEWPORT_EDGE_PADDING = 10;

  $(document).on("mouseenter", ".button-dropdown", function () {
    const $dropdown = $(this);
    const $menu = $dropdown.find(".dropdown-menu");

    clearButtonDropdownTimeout($dropdown);
    $dropdown.addClass("open");
    adjustButtonDropdownPosition($dropdown, $menu);
  });

  $(document).on("mouseleave", ".button-dropdown", function () {
    scheduleButtonDropdownClose($(this));
  });

  $(document).on("mouseenter", ".button-dropdown .dropdown-menu", function () {
    clearButtonDropdownTimeout($(this).closest(".button-dropdown"));
  });

  $(document).on("mouseleave", ".button-dropdown .dropdown-menu", function () {
    scheduleButtonDropdownClose($(this).closest(".button-dropdown"));
  });

  function clearButtonDropdownTimeout($dropdown) {
    const existingTimeout = $dropdown.data("close-timeout");
    if (existingTimeout) {
      clearTimeout(existingTimeout);
      $dropdown.removeData("close-timeout");
    }
  }

  function scheduleButtonDropdownClose($dropdown) {
    const closeTimeout = setTimeout(function () {
      $dropdown.removeClass("open");
      $dropdown.removeData("close-timeout");
    }, CLOSE_DELAY);

    $dropdown.data("close-timeout", closeTimeout);
  }

  function adjustButtonDropdownPosition($dropdown, $menu) {
    if (!$menu.length || !$menu[0]) return;

    const menuRect = $menu[0].getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    if (menuRect.right > viewportWidth - VIEWPORT_EDGE_PADDING) {
      $dropdown.addClass("align-right");
    } else {
      $dropdown.removeClass("align-right");
    }

    if (menuRect.bottom > viewportHeight - VIEWPORT_EDGE_PADDING) {
      $dropdown.addClass("align-top");
    } else {
      $dropdown.removeClass("align-top");
    }
  }
}

// Initialize button dropdowns too
$(document).ready(fixButtonDropdowns);
